import type { Experiments, SiteAssetsExperimentMetadata } from '@wix/thunderbolt-symbols'
import { siteAssetsModules } from './siteAssetsModules'

const createExperiments = <T extends Record<string, SiteAssetsExperimentMetadata>>(obj: T) => obj

export const beckySpecs = createExperiments({
	'specs.thunderbolt.dynamicSlots': {
		modules: ['thunderbolt-features', 'thunderbolt-css', 'thunderbolt-css-mappers', 'thunderbolt-platform'],
	},
	'specs.thunderbolt.forwardRef': {
		modules: ['thunderbolt-features', 'thunderbolt-css'],
	},
	'specs.thunderbolt.encodeUris': { modules: ['thunderbolt-features'] },
	'specs.thunderbolt.fixRemappedFullNameCompType': { modules: ['thunderbolt-features'] },
	'specs.thunderbolt.fixSectionAnchorUrlHash': { modules: ['thunderbolt-features'] },
	'specs.thunderbolt.debugOriginalBeckyModel': { modules: ['thunderbolt-features'] },
	'specs.thunderbolt.textMaskFontFallbacks': { modules: ['thunderbolt-css'] },
	'specs.thunderbolt.fixRatingsInputLeftShift': {
		modules: ['thunderbolt-features', 'thunderbolt-css', 'thunderbolt-css-mappers', 'thunderbolt-platform'],
	},
	dm_changeCSMKeys: {
		modules: ['thunderbolt-features', 'thunderbolt-platform', 'thunderbolt-site-map'],
	},
	'specs.thunderbolt.deprecateAppId': {
		modules: ['thunderbolt-features', 'thunderbolt-platform', 'thunderbolt-site-map'],
	},
	'specs.thunderbolt.newControllersModel': {
		modules: ['thunderbolt-platform', 'thunderbolt-features'],
	},
	'specs.thunderbolt.breakingBekyCache': { modules: siteAssetsModules }, // closed by default. used only for urgent cases which require breaking tb modules cache
	'specs.thunderbolt.DatePickerPortal': {
		modules: ['thunderbolt-features', 'thunderbolt-platform', 'thunderbolt-css', 'thunderbolt-css-mappers'],
	},
	'specs.thunderbolt.LinkBarPlaceholderImages': {
		modules: ['thunderbolt-features', 'thunderbolt-platform'],
	},
	'specs.thunderbolt.repeater_keyboard_navigation': { modules: ['thunderbolt-features', 'thunderbolt-platform'] },
	'specs.thunderbolt.dropdownOptionStyle': { modules: ['thunderbolt-features', 'thunderbolt-platform'] },
	'specs.thunderbolt.mpaViewTransitionsCssFeature': {
		modules: ['thunderbolt-features', 'thunderbolt-css', 'thunderbolt-css-mappers'],
	},
	'specs.thunderbolt.shouldUseResponsiveImages': { modules: ['thunderbolt-features'] },
	'specs.thunderbolt.useResponsiveImgClassicFixed': { modules: ['thunderbolt-features'] },
	'specs.thunderbolt.DDMenuMigrateCssCarmiMapper': { modules: ['thunderbolt-css', 'thunderbolt-css-mappers'] },
	'specs.thunderbolt.designableListForMobileDropdown': {
		modules: ['thunderbolt-features', 'thunderbolt-platform'],
	},
	'specs.thunderbolt.designStates': { modules: ['thunderbolt-css', 'builder-component-css'] },
	'specs.thunderbolt.fiveGridLineStudioSkins': {
		modules: ['thunderbolt-features', 'thunderbolt-platform'],
	},
	'specs.thunderbolt.takeTranslationsFromManifest': {
		modules: ['thunderbolt-features'],
	},
	'specs.thunderbolt.keepTextInputHeight': { modules: ['thunderbolt-features', 'thunderbolt-platform'] },
	'specs.thunderbolt.calculateCollapsibleTextLineHeightByFont': {
		modules: ['thunderbolt-features', 'thunderbolt-platform'],
	},
	'specs.thunderbolt.migrateStylableComponentsInBlocksWidgets': { modules: siteAssetsModules }, // Internal Use
	'specs.thunderbolt.shouldIgnoreWidgetsPageData': {
		modules: ['thunderbolt-features', 'thunderbolt-platform', 'thunderbolt-site-map'],
	},
	'specs.thunderbolt.dontApplyDacOverridesOnBoBApps': { modules: ['thunderbolt-features'] },
	'specs.thunderbolt.doNotInflateSharedParts': {
		modules: [
			'thunderbolt-features',
			'thunderbolt-css',
			'thunderbolt-css-mappers',
			'thunderbolt-platform',
			'thunderbolt-site-map',
		],
	},
	'specs.thunderbolt.namedRanges': {
		modules: ['thunderbolt-css'],
	},
	'specs.thunderbolt.globalVarsRefactor23': {
		modules: ['thunderbolt-css'],
	},
	'specs.thunderbolt.resolveSpxWithoutEditorCheck': {
		modules: ['thunderbolt-css'],
	},
	'specs.thunderbolt.builderBoxSizingBorderBox': {
		modules: ['thunderbolt-features'],
	},
	'specs.thunderbolt.renderPlatformBuilderComponent': {
		modules: [
			'thunderbolt-features',
			'thunderbolt-css',
			'thunderbolt-css-mappers',
			'thunderbolt-platform',
			'thunderbolt-site-map',
		],
	},
	'specs.thunderbolt.TextInputAutoFillFix': { modules: ['thunderbolt-features', 'thunderbolt-platform'] },
	'specs.thunderbolt.buttonUdp': { modules: ['thunderbolt-features', 'thunderbolt-platform'] },
	'specs.thunderbolt.A11yWPhotoPopupSemanticsAndKeyboardOperability': {
		modules: ['thunderbolt-features', 'thunderbolt-platform'],
	},
	'specs.thunderbolt.one_cell_grid_display_flex': { modules: ['thunderbolt-css', 'thunderbolt-css-mappers'] },
	'specs.thunderbolt.one_cell_grid_display_flex_header_height': {
		modules: ['thunderbolt-css', 'thunderbolt-css-mappers'],
	},
	'specs.thunderbolt.ooiCssAsLinkTag': { modules: ['thunderbolt-css', 'thunderbolt-css-mappers'] },
	'specs.thunderbolt.motionBgScrub': {
		modules: ['thunderbolt-features', 'thunderbolt-css', 'thunderbolt-css-mappers'],
	},
	'specs.thunderbolt.motionTimeAnimationsCSS': { modules: ['thunderbolt-features', 'thunderbolt-css'] },
	'specs.thunderbolt.motionScrollCSS': { modules: ['thunderbolt-css'] },
	'specs.thunderbolt.sandboxForCustomElement': {
		modules: ['thunderbolt-features', 'thunderbolt-platform'],
	},
	'specs.thunderbolt.fixCustomElementInWidgetInRepeater': { modules: ['thunderbolt-features'] },
	'specs.thunderbolt.forceStudio': { modules: siteAssetsModules }, // internal experiment, not for public use
	'specs.thunderbolt.useSvgLoaderFeature': { modules: ['thunderbolt-features'] },
	'specs.thunderbolt.useSvgLoaderFeatureOnBuilderComps': { modules: ['thunderbolt-features'] },
	'specs.thunderbolt.builderSvgCssVars': { modules: ['thunderbolt-css'] },
	'specs.thunderbolt.useClassnameInResponsiveAppWidget': {
		modules: ['thunderbolt-features', 'thunderbolt-platform'],
	},
	'specs.thunderbolt.isClassNameToRootEnabled': {
		modules: ['thunderbolt-features', 'thunderbolt-platform', 'thunderbolt-css', 'thunderbolt-css-mappers'],
	},
	'specs.thunderbolt.resolveManifestInTB': {
		modules: [
			'thunderbolt-features',
			'thunderbolt-platform',
			'thunderbolt-css',
			'thunderbolt-css-mappers',
			'component-manifest-css',
		],
	},
	'specs.thunderbolt.WixFreeSiteBannerDesktop': {
		modules: ['thunderbolt-features', 'thunderbolt-css', 'thunderbolt-css-mappers', 'thunderbolt-platform'],
	},
	'specs.thunderbolt.WixFreeSiteBannerMobile': {
		modules: ['thunderbolt-features', 'thunderbolt-css', 'thunderbolt-css-mappers', 'thunderbolt-platform'],
	},
	'specs.thunderbolt.FreemiumBannerOdeditor': {
		modules: ['thunderbolt-features', 'thunderbolt-css', 'thunderbolt-css-mappers', 'thunderbolt-platform'],
	},
	'specs.thunderbolt.svgResolver_2': {
		modules: ['thunderbolt-features', 'thunderbolt-platform'],
	},
	'specs.thunderbolt.removeSafariStickyFix': {
		modules: ['thunderbolt-css'],
	},
	'specs.thunderbolt.safariStickyFix': {
		modules: ['thunderbolt-css'],
	},
	'specs.thunderbolt.imageEncodingAVIF': { modules: ['thunderbolt-features'] },
	'specs.thunderbolt.image3AboveTheFold': { modules: ['thunderbolt-features'] },
	'specs.thunderbolt.updateRichTextSemanticClassNamesOnCorvid': {
		modules: ['thunderbolt-features', 'thunderbolt-platform'],
	},
	'specs.thunderbolt.useWixMediaCanvas': { modules: ['thunderbolt-features'] },
	'specs.thunderbolt.LoginBarEnableLoggingInStateInSSR': {
		modules: ['thunderbolt-features', 'thunderbolt-platform'],
	},
	'specs.thunderbolt.servicesInfra': {
		modules: ['thunderbolt-features'],
	},
	'specs.thunderbolt.dummySATestCacheImpact': {
		modules: ['thunderbolt-css'],
	},
	'specs.thunderbolt.expandableMenuItemSubItemColor': {
		modules: ['thunderbolt-features', 'thunderbolt-platform'],
	},
	'specs.thunderbolt.showContentReflowBanner': {
		modules: [
			'thunderbolt-features',
			'thunderbolt-css',
			'thunderbolt-css-mappers',
			'thunderbolt-platform',
			'thunderbolt-site-map',
		],
	},
	'specs.thunderbolt.DisableDocumentScrollWhenLightBoxOpen': {
		modules: ['thunderbolt-features'],
	},
	'specs.thunderbolt.overflowXClipHeaderAndFooter': { modules: ['thunderbolt-features'] },
	'specs.thunderbolt.whitelistedSpecForTesting': { modules: [] },
	'specs.thunderbolt.eeFixedGradiantBackground': { modules: ['thunderbolt-css'] },
	'specs.thunderbolt.useWowImageInFastGallery': { modules: ['thunderbolt-features', 'thunderbolt-platform'] },
	'specs.thunderbolt.extractLanguageCode': {
		modules: ['thunderbolt-features', 'thunderbolt-css', 'thunderbolt-css-mappers', 'thunderbolt-platform'],
	},
	'specs.thunderbolt.useImageAvifFormatInNativeProGallery': {
		modules: ['thunderbolt-features', 'thunderbolt-platform'],
	},
	'specs.thunderbolt.forceMpaNavigation': {
		modules: ['thunderbolt-features'],
	},
	'specs.thunderbolt.expandableMenuNewDirectionality': {
		modules: ['thunderbolt-css', 'thunderbolt-features', 'thunderbolt-platform'],
	},
	'specs.thunderbolt.ClassicRepeaterOrderFix': {
		modules: ['thunderbolt-features', 'thunderbolt-platform'],
	},
	'specs.thunderbolt.dom_store': {
		modules: ['thunderbolt-features'],
	},
	'specs.thunderbolt.pinnedTopAuto': {
		modules: ['thunderbolt-css'],
	},
	'specs.thunderbolt.interactionsFeature': {
		modules: ['thunderbolt-features', 'thunderbolt-css', 'thunderbolt-css-mappers'],
	},
	'specs.thunderbolt.interactionsUseReactionEffectId': { modules: ['thunderbolt-features'] },
	'specs.thunderbolt.interactionsInSsr': {
		modules: ['thunderbolt-features', 'thunderbolt-css', 'thunderbolt-css-mappers'],
	},
	'specs.thunderbolt.motionBackgroundSiteParallax': { modules: ['thunderbolt-features'] },
	'specs.thunderbolt.withInteractionsHOC': { modules: ['thunderbolt-features', 'thunderbolt-css'] },
	'specs.thunderbolt.EnableCustomCSSVarsForLoginSocialBar': {
		modules: ['thunderbolt-features', 'thunderbolt-platform', 'thunderbolt-css', 'thunderbolt-css-mappers'],
	},
	'specs.thunderbolt.useClassSelectors': {
		modules: ['thunderbolt-css', 'thunderbolt-css-mappers', 'thunderbolt-platform', 'thunderbolt-features'],
	},
	'specs.thunderbolt.addIdAsClassName': {
		modules: ['thunderbolt-features', 'thunderbolt-platform'],
	},
	'specs.thunderbolt.useClassSelectorsForLookup': {
		modules: ['thunderbolt-css', 'thunderbolt-css-mappers', 'thunderbolt-platform', 'thunderbolt-features'],
	},
	'specs.thunderbolt.scopeRepeatedSelectors': {
		modules: ['thunderbolt-css', 'thunderbolt-css-mappers'],
	},
	'specs.thunderbolt.ooiCssSelectorWithSuffix': {
		modules: ['thunderbolt-css-mappers'],
	},
	'specs.thunderbolt.reactGoogleMaps': {
		modules: ['thunderbolt-features', 'thunderbolt-platform'],
	},
	'specs.thunderbolt.increaseFocusRing': {
		modules: ['thunderbolt-css'],
	},
	'specs.thunderbolt.a11yContrast': {
		modules: ['thunderbolt-features'],
	},
	'specs.thunderbolt.vsm_shapes': {
		modules: ['thunderbolt-css', 'thunderbolt-features', 'thunderbolt-platform'],
	},
	'specs.thunderbolt.UseNewLoginSocialBarMemberInitialsAvatar': {
		modules: ['thunderbolt-features', 'thunderbolt-platform'],
	},
	'specs.thunderbolt.UseLoginSocialBarCustomMenu': {
		modules: ['thunderbolt-features', 'thunderbolt-platform'],
	},
	'specs.thunderbolt.css_nesting_selectors': { modules: ['thunderbolt-css-mappers'] },
	'specs.thunderbolt.customScaleMinBreakpoint': {
		modules: ['thunderbolt-css'],
	},
	'specs.thunderbolt.UseNewLoginSocialBarElementStructure': {
		modules: ['thunderbolt-features', 'thunderbolt-platform'],
	},
	'specs.thunderbolt.HoverBoxSelectorToCssNativeMapper': {
		modules: ['thunderbolt-css-mappers'],
	},
	'specs.thunderbolt.vsm_css': {
		modules: ['thunderbolt-css', 'thunderbolt-css-mappers'],
	},
	'specs.thunderbolt.dontFilterSlots': {
		modules: ['thunderbolt-features'],
	},
	'specs.thunderbolt.proGalleryHeightFixer': {
		modules: ['thunderbolt-features', 'thunderbolt-platform'],
	},
	'specs.thunderbolt.allowFullGIFTransformation': {
		modules: ['thunderbolt-features'],
	},
	'specs.thunderbolt.allowWebpAvifTransforms': {
		modules: ['thunderbolt-features'],
	},
	'specs.thunderbolt.removeSingleTabCssMapper': {
		modules: ['thunderbolt-css-mappers'],
	},
	'specs.thunderbolt.vsmPageConfigs': {
		modules: ['thunderbolt-features'],
	},
	'specs.thunderbolt.sectionA11yProps': {
		modules: ['thunderbolt-features'],
	},
	'specs.thunderbolt.responsiveContainerRoleGroup': {
		modules: ['thunderbolt-features'],
	},
	'specs.thunderbolt.customImageDomain': {
		modules: ['thunderbolt-features', 'thunderbolt-css', 'thunderbolt-css-mappers', 'thunderbolt-platform'],
	},
	'specs.thunderbolt.builderComponentSlotsInPlatform': {
		modules: ['thunderbolt-platform'],
	},
	'specs.thunderbolt.vsmStructure': {
		modules: ['thunderbolt-features'],
	},
	'specs.thunderbolt.vsmPropsMappers': {
		modules: ['thunderbolt-features'],
	},
	'specs.thunderbolt.vsmFeaturesModule': {
		modules: ['thunderbolt-features'],
	},
	'specs.thunderbolt.logVsmFeaturesModuleDiff': {
		modules: ['thunderbolt-features'],
	},
	'specs.thunderbolt.vsmPlatform': {
		modules: ['thunderbolt-platform'],
	},
	'specs.thunderbolt.UseNestedLoginSocialBarMenuItems': {
		modules: ['thunderbolt-features', 'thunderbolt-platform'],
	},
	'specs.thunderbolt.shouldRoundCssSpxValues': {
		modules: ['thunderbolt-css', 'thunderbolt-css-mappers'],
	},
	'specs.thunderbolt.shouldFixContainerOverflowCollapse': {
		modules: ['thunderbolt-css', 'thunderbolt-css-mappers'],
	},
	'specs.thunderbolt.cssHamburgerPreHydration': {
		modules: ['thunderbolt-features'],
	},
	'specs.thunderbolt.UseNewLoginBarDropdownMenuAlignment': {
		modules: ['thunderbolt-features', 'thunderbolt-platform'],
	},
	'specs.thunderbolt.useNativeMapperForLoginSocialBarSdkData': {
		modules: ['thunderbolt-features', 'thunderbolt-platform'],
	},
	'specs.thunderbolt.stringifyHashPresetName': {
		modules: ['thunderbolt-css', 'component-manifest-css'],
	},
	'specs.thunderbolt.stringifyHashPresetName_VAG': {
		modules: ['thunderbolt-css', 'component-manifest-css'],
	},
	'specs.thunderbolt.stopResolvingInnerSelectors_VAG': {
		modules: [
			'thunderbolt-features',
			'thunderbolt-css',
			'thunderbolt-css-mappers',
			'thunderbolt-platform',
			'builder-component-features',
			'builder-component-css',
			'builder-component-platform',
			'component-manifest-css',
		],
	},
	'specs.thunderbolt.fixFirefoxLinkBarIntrinsicSizing': {
		modules: ['thunderbolt-features', 'thunderbolt-platform'],
	},
	'specs.thunderbolt.migrateSdkDataMappers': { modules: ['thunderbolt-platform'] },
	'specs.thunderbolt.useFragmentHrefForTopBottomAnchor': { modules: ['thunderbolt-features'] },
	'specs.thunderbolt.LoginBarEnableSkeletonLoader': {
		modules: ['thunderbolt-features', 'thunderbolt-platform'],
	},
	'specs.thunderbolt.vsmSiteMap': { modules: ['thunderbolt-site-map'] },
	'specs.thunderbolt.logVsmSiteMapDiff': { modules: ['thunderbolt-site-map'] },
	'specs.thunderbolt.logVsmPlatformDiff': { modules: ['thunderbolt-platform'] },
})

/*
 * This list contains experiments names that are relevant to code running in site-assets (A.K.A Becky)
 * They are available via envApi.getExperiments() for carmi code and compInfo['experiments'] for components mappers
 * If the code that uses the experiment runs in feature - you don't need to add it here
 * See becky experiment guidelines here: https://wix.slack.com/canvas/C4D8A09PZ
 * */
export type beckyWhitelistSpecType = keyof typeof beckySpecs
export const beckyWhitelist = Object.keys(beckySpecs) as Array<beckyWhitelistSpecType>

/*
 * This list contains experiments names that are relevant to data-fixer code running in site-assets
 * They are passed to becky (site-assets modules) so that it can get fixed JSONs as input
 * Add only data-fixers experiments relevant to TB (they will be sent only if the experiment is open in thunderbolt-viewer scope)
 * */
export const dataFixersSpecsWhitelist = [
	'sv_migrateTpaToSemiNative',
	'bv_migrateAbsoluteLayoutToDataMaps',
	'bv_scrollEffectsFixer',
	'bv_migrate',
	'bv_migrateResponsiveLayoutToSingleLayoutData',
	'dm_removeMissingResponsiveRefs',
	'bv_removeMenuDataFromPageJson',
	'dm_fixMobileSplitInVariantNs',
	'dm_fixMobileSplitDesign',
	'dm_keepChildlessAppWidget',
	'dm_removeResponsiveDataFromClassicEditorFixer',
	'dm_enableDefaultA11ySettings',
	'dm_linkRelDefaults',
	'dm_pageWithItemLayoutFixer',
	'dm_migrateCollapsibleTextToNonStylable',
	'dm_migrateBreadcrumbsToNonStylable',
	'dm_migrateStylableButtonToNonStylable',
	'dm_migrateSelectableContainerInput',
	'dm_migrateSelectableContainerToNonStylable',
	'dm_migrateBlocksWidgetsToNonStylable',
	'dm_migrateProGalleryToNonStylable',
]

/*
 * This list contains experiments names that are relevant to data-fixer code running in site-assets
 * They are passed to becky (site-assets modules) so that it can get fixed JSONs as input
 * These experiments are always sent, regardless of conduction in thunderbolt-viewer scope.
 * */
export const hardCodedListOfDataFixersExperiments: Experiments = {}
